import React from 'react';
import Container from '../../../containers/subject/subjectClasses/showSubjectClassContainer';

export default function () {
  return (
    <Container />
  );
}
